import { addHours, createDate, endOfHour, toUTCString } from '@lingoda/dates';
import { useStudentPastAppointmentsCountQuery } from '@lingoda/graphql';

export const useHasPastAppointments = () => {
    const { data } = useStudentPastAppointmentsCountQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            pastToDate: toUTCString(endOfHour(addHours(createDate(), -1))),
        },
    });

    return !!data?.pastAppointmentsCount;
};
